import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, useTheme, useMediaQuery, Tooltip } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import QueryWidget from '../../Components/QueryWidget/query-widget.tsx';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import DatePicker from '../../Components/DatePicker/date-picker.tsx';
import ConfirmationPopup from '../../Components/ConfirmationModal/confirmation-modal.tsx';
import useTableHeight from '../../Utils/TableHeight/table-height.tsx';
import formatDate from '../../Utils/DateFormat/date-format.tsx';
import getCurrentDate from '../../Utils/CurrentDate/current-date.tsx';
import LocationModal from '../Trips/location-modal.tsx';
import TripDetailsModal from './trip-details-modal.tsx';
import AddVehicleModal from '../Vehicles/add-vehicle-modal.tsx';
import AddIcon from '@mui/icons-material/Add';
import EditTripModal from './edit-trip-modal.tsx';
import EditVehicleModal from '../Vehicles/edit-vehicle-modal.tsx';
import { getVehicle, getTrips, editRemarks, getWarehouseCompanyMapping, getAbsentVehicles,getWarehouses, getCurrentLocation, getCompanies, deleteTrip } from '../Trips/action.ts';
import { Trip, Vehicle } from './types.ts';
import TripsMobileView from './trips-mobile-view.tsx';
import TripsDesktopView from './trips-desktop-view.tsx';
import VehiclesPlatformView from './vehicles-platform-view.tsx';
import '../../Components/Button/button-style.scss';
import '../../Components/Table/table-style.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Trips: React.FC = () => {
    const [totalCount, setTotalCount] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [warehouseOptions, setWarehouseOptions] = useState<{ id: string, label: string }[]>([]);
    const [selectedFromDate, setSelectedFromDate] = useState<string>('');
    const [selectedToDate, setSelectedToDate] = useState<string>('');
    const [selectedVehicle, setSelectedVehicle] = useState<any>('');
    const [vehicleOptions, setVehicleOptions] = useState<{ id: string, label: string }[]>([]);
    const [selectedFuelType, setSelectedFuelType] = useState<string>('');
    const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string, name: string } | null>(null);
    const [tripsForRender, setTripsForRender] = useState<Trip[]>([]);
    const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
    const [searchTerm, setSearchTerm] = useState('');
    const [absentTrips, setAbsentTrips] = useState<Trip[]>([]);
    const [absentPage, setAbsentPage] = useState<number>(0);
    const [isFetchingAbsent, setIsFetchingAbsent] = useState<boolean>(false);
    const [hasMoreAbsent, setHasMoreAbsent] = useState<boolean>(true);
    const [remarksList, setRemarksList] = useState<{ [key: number]: string }>({});
    const [startReadingList, setStartReadingList] = useState<{ [key: number]: string }>({});
    const [endReadingList, setEndReadingList] = useState<{ [key: number]: string }>({});
    const [modalOpen, setModalOpen] = useState(false);
    const [tripDetailsModalOpen, setTripDetailsModalOpen] = useState(false);
    const [modalStartLocation, setModalStartLocation] = useState<string>('');
    const [modalEndLocation, setModalEndLocation] = useState<string>('');
    const [selectedTripOrdersPicked, setSelectedTripOrdersPicked] = useState<number>(0);
    const [selectedTripOrdersDelivered, setSelectedTripOrdersDelivered] = useState<number>(0);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [isAddVehicleOpen, setIsAddVehicleOpen] = useState(false);
    const [ordersPickedList, setOrdersPickedList] = useState<{ [key: number]: string }>({});
    const [ordersDeliveredList, setOrdersDeliveredList] = useState<{ [key: number]: string }>({});
    const [totalTripsOnlyCount, setTotalTripsOnlyCount] = useState<number>(0);
    const [tripId, setTripId] = useState<string>('');
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const [vehicleId, setVehicleId] = useState<string>('');
    const companiesId = userDetailsFromStorage?.companies_id || '';
    const defaultTabLogic = String(companiesId) === '1' ? 'On Trip' : 'All';
    const savedTab = sessionStorage.getItem('trips_active_tab');
    const initialTab = savedTab ? savedTab : defaultTabLogic;
    const [activeMobileFilter, setActiveMobileFilter] = useState(initialTab);
    const [dynamicStatus, setDynamicStatus] = useState(initialTab !== 'All' ? initialTab : 'On Trip');
    const initialStatusMap: Record<string, string> = { 
    'Idle': 'idle', 
    'On Trip': 'on_trip', 
    'Absent': '', 
    'All': '' 
    };
    const [vehicleStatus, setVehicleStatus] = useState<string>(initialStatusMap[initialTab] || '');
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedEditTrip, setSelectedEditTrip] = useState<any | null>(null);
    const [vehicleList, setVehicleList] = useState<Vehicle[]>([]);
    const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
    const [modalType, setModalType] = useState<'start' | 'end' | 'handover' | null>(null);
    const [confirmTitle, setConfirmTitle] = useState("");
    const [confirmMessage, setConfirmMessage] = useState("");
    const [isFetchingTrips, setIsFetchingTrips] = useState<boolean>(false);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState<any>(null);
    const [showMap, setShowMap] = useState(false);
    const [statusMenuAnchor, setStatusMenuAnchor] = useState<null | HTMLElement>(null);
    const [activeTripId, setActiveTripId] = useState<number | null>(null);   
    const [tempCombinedOrders, setTempCombinedOrders] = useState<{ [key: number]: string }>({});
    const [tempCombinedOdometer, setTempCombinedOdometer] = useState<{ [key: number]: string }>({});
    const navigate = useNavigate();
    const orderRef = useRef<any>();
    const mapRef = useRef<google.maps.Map | null>(null);
    const lastFetchedVehicleRef = useRef<string>('');
    const tableHeight = useTableHeight(250);
    const theme = useTheme();
    const [isSearching, setIsSearching] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isLoggedIn = !!localStorage.getItem("userdetails");
    const userRole = userDetailsFromStorage?.role?.toLowerCase();
    const isClientCompanyAdmin = userRole === 'client_company_admin';

    const showEntries = [{ id: '10', label: '10' }, { id: '20', label: '20' }, { id: '50', label: '50' }, { id: '100', label: '100' }];
    const fuelTypeOptions = [{ id: 'diesel', label: 'Diesel' }, { id: 'EV', label: 'EV' }, { id: 'petrol', label: 'Petrol' }, { id: 'CNG', label: 'CNG' }];
    const tripOptions = ['On Trip', 'Idle', 'Absent'];
    const currentTabs = useMemo(() => {
        const secondTab = activeMobileFilter === 'All' ? dynamicStatus : activeMobileFilter;
        return ['All', secondTab];
    }, [activeMobileFilter, dynamicStatus]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/');
        }
        const today = getCurrentDate();
        setSelectedFromDate(today);
        setSelectedToDate(today);
        fetchWarehouses();
    }, [isLoggedIn]);

    useEffect(() => {
        fetchVehicles();
    }, [selectedWarehouse, selectedFuelType]);

    useEffect(() => {
        if (isSearching) {
            return;
        }
        setPage(0);
        setTripsForRender([]);
        setTotalRecords(0);
        setAbsentTrips([]);
        setAbsentPage(0);
        setHasMoreAbsent(true);
        setTotalTripsOnlyCount(0);
        setTempCombinedOrders({});
        setTempCombinedOdometer({});
    }, [activeMobileFilter, selectedVehicle, selectedWarehouse, selectedFuelType, selectedFromDate, selectedToDate, isSearching]);

    useEffect(() => {

        if (selectedFromDate && selectedToDate) {
            if (isSearching) {
                return;
            }
            if (activeMobileFilter === 'All') {
                fetchData();
            }
            else if (activeMobileFilter === 'On Trip' || activeMobileFilter === 'Idle') {
                fetchTripsData(); 
            }
            else if (activeMobileFilter === 'Absent') {
                fetchSpecialStatusVehicles();
            }
            else {
                fetchData();
            }
        }
    }, [pageSize, page, selectedFromDate, selectedToDate, selectedWarehouse, selectedVehicle, selectedFuelType, activeMobileFilter, vehicleStatus, isMobile, selectedCompany, isSearching]);

    useEffect(() => {
        setActiveTripId(null);
        setTimeout(() => {
            fitMapToAllTrips();
        }, 100);
    }, [activeMobileFilter, tripsForRender]);

    useEffect(() => {
        if (selectedVehicle && lastFetchedVehicleRef.current !== selectedVehicle) {
            lastFetchedVehicleRef.current = selectedVehicle;
            fetchAbsentVehiclesForSelectedVehicle();
        }
    }, [selectedVehicle, activeMobileFilter]);

    const fetchAbsentVehiclesForSelectedVehicle = () => {
        setIsFetchingTrips(true);
        const currentOption = vehicleOptions.find(v => String(v.id) === String(selectedVehicle));
        const vehicleNumberPlate = currentOption ? currentOption.label : '';

        getTrips(pageSize, page, selectedFromDate, selectedToDate,
            (response: any) => {
                if (response.status === 200 && response.message?.trips_list && response.message.trips_list.length > 0) {
                    setIsFetchingTrips(false);
                    const tripsList = (response.message.trips_list || []).map((trip: any) => ({
                        ...trip,
                        start_latitude: trip.start_lat ? Number(trip.start_lat) : null,
                        start_longitude: trip.start_lng ? Number(trip.start_lng) : null,
                        end_latitude: trip.end_lat ? Number(trip.end_lat) : null,
                        end_longitude: trip.end_lng ? Number(trip.end_lng) : null,
                    }));
                    
                    setTotalCount(Math.ceil(response.message.total_trips_count / pageSize));
                    setTotalRecords(response.message.total_trips_count);
                    setTripsForRender(tripsList);
                     if (tripsList.length > 0) {
                        const hasIdleTrips = tripsList.some((trip: Trip) => trip.start_time && trip.end_time);
                        const hasOnTripTrips = tripsList.some((trip: Trip) => trip.start_time && !trip.end_time);
                        
                        if (hasIdleTrips) {
                            setActiveMobileFilter('Idle');
                            sessionStorage.setItem('trips_active_tab', 'Idle');
                            setDynamicStatus('Idle');
                            setVehicleStatus('idle');
                        } else if (hasOnTripTrips) {
                            setActiveMobileFilter('On Trip');
                            sessionStorage.setItem('trips_active_tab', 'On Trip');
                            setDynamicStatus('On Trip');
                            setVehicleStatus('on_trip');
                        }
                    }
                } else {
                    getVehicle(pageSize, page,
                        (vehicleResponse: any) => {
                            setIsFetchingTrips(false);
                            if (vehicleResponse.status === 200 && vehicleResponse.message?.vehicles_list && vehicleResponse.message.vehicles_list.length > 0) {
                                const total = vehicleResponse.message.total_vehicles_count || 0;
                                setTotalRecords(total);
                                setTotalCount(Math.ceil(total / pageSize));
                                setVehicleList(vehicleResponse.message.vehicles_list);
                                const mappedVehicles: Trip[] = vehicleResponse.message.vehicles_list.map((v: any) => ({
                                    id: v.id,
                                    vehicles_id: v.id.toString(),
                                    companies_id: v.companies_id,
                                    number_plate: v.number_plate,
                                    status: 'Absent', 
                                    driver_name: v.driver_name || 'No Driver',
                                    driver_phone: v.driver_phone,
                                    current_location: v.current_location,
                                    start_time: '',
                                    end_time: '',
                                    start_location: v.current_location?.address || 'Device not installed',
                                    end_location: '',
                                    odometer_start: 0,
                                    odometer_end: 0,
                                    gps_kms: 0,
                                    remarks: '',
                                    orders_picked: 0,
                                    orders_delivered: 0,
                                    initiated_by: 'system',
                                    owner_name: v.owner_name,
                                    make_model: v.make_model,
                                    reg_date: v.reg_date,
                                    fuel_type: v.fuel_type
                                }));
                                setTripsForRender(mappedVehicles);
                                setActiveMobileFilter('Absent');
                                sessionStorage.setItem('trips_active_tab', 'Absent');
                                setDynamicStatus('Absent');
                                setVehicleStatus('');
                            } else {
                                setTripsForRender([]);
                                setTotalRecords(0);
                            }
                        },
                        (errMessage: any) => {
                            setIsFetchingTrips(false);
                            setTripsForRender([]);
                            toast.error(typeof errMessage === 'string' ? errMessage : "Failed to fetch data");
                        },
                        { absent: 1 }, 
                        vehicleNumberPlate,
                        '',
                        selectedWarehouse?.name || '',
                        selectedFuelType,
                    );
                }
            },
            (errMessage: any) => {
                getVehicle(pageSize, page,
                    (vehicleResponse: any) => {
                        setIsFetchingTrips(false);
                        if (vehicleResponse.status === 200 && vehicleResponse.message?.vehicles_list && vehicleResponse.message.vehicles_list.length > 0) {
                            const total = vehicleResponse.message.total_vehicles_count || 0;
                            setTotalRecords(total);
                            setTotalCount(Math.ceil(total / pageSize));
                            setVehicleList(vehicleResponse.message.vehicles_list);
                            const mappedVehicles: Trip[] = vehicleResponse.message.vehicles_list.map((v: any) => ({
                                id: v.id,
                                vehicles_id: v.id.toString(),
                                companies_id: v.companies_id,
                                number_plate: v.number_plate,
                                status: 'Absent', 
                                driver_name: v.driver_name || 'No Driver',
                                driver_phone: v.driver_phone,
                                current_location: v.current_location,
                                start_time: '',
                                end_time: '',
                                start_location: v.current_location?.address || 'Device not installed',
                                end_location: '',
                                odometer_start: 0,
                                odometer_end: 0,
                                gps_kms: 0,
                                remarks: '',
                                orders_picked: 0,
                                orders_delivered: 0,
                                initiated_by: 'system',
                                owner_name: v.owner_name,
                                make_model: v.make_model,
                                reg_date: v.reg_date,
                                fuel_type: v.fuel_type
                            }));
                            setTripsForRender(mappedVehicles);
                            setActiveMobileFilter('Absent');
                            sessionStorage.setItem('trips_active_tab', 'Absent');
                            setDynamicStatus('Absent');
                            setVehicleStatus('');
                        } else {
                            setTripsForRender([]);
                            setTotalRecords(0);
                        }
                    },
                    (vehicleError: any) => {
                        setIsFetchingTrips(false);
                        setTripsForRender([]);
                        toast.error(typeof vehicleError === 'string' ? vehicleError : "Failed to fetch data");
                    },
                    { absent: 1 }, 
                    vehicleNumberPlate, 
                    '',
                    selectedWarehouse?.name || '',
                    selectedFuelType,
                );
            },
            [selectedVehicle], 
            selectedWarehouse?.name || '',
            selectedFuelType,
            ''
        );
    };

    const fetchVehicles = () => {
        getVehicle(100,
            0, 
            (response: any) => {
            setVehicleList(response.message?.vehicles_list);
            const options = response.message?.vehicles_list.map((vehicle: any) => ({
                id: vehicle.id,
                label: vehicle.number_plate,
            }));
            setVehicleOptions(options);
        }, 
        (errMessage: any) => { toast.error(errMessage); setVehicleOptions([]); }, 
        { active: 1 }, '', '',selectedWarehouse?.name || '', selectedFuelType
        );
    };


const fetchWarehouses = () => {
       if (userRole === 'vendor_supervisor') {
        getWarehouses(
            0,      
            "100",
            "", 
            (response: any) => {
                const list = response.message?.warehouses 
                    || response.data?.warehouses 
                    || (Array.isArray(response.message) ? response.message : null)
                    || (Array.isArray(response.data) ? response.data : []) 
                    || []; 
                
                const options = list.map((warehouse: any) => ({
                    id: warehouse.id,
                    label: warehouse.name,
                }));
                setWarehouseOptions(options);
            },
            (errMessage: any) => { 
                toast.error(typeof errMessage === 'string' ? errMessage : errMessage?.message || "Failed to fetch warehouses"); 
            }
        );
    }else {
            getWarehouseCompanyMapping(companiesId,
                (response: any) => {
                    const options = response.user_warehouses.map((warehouses: any) => ({
                        id: warehouses.warehouse.id,
                        label: warehouses.warehouse.name,
                    }));
                    setWarehouseOptions(options);
                },
                (errMessage: any) => { 
                    toast.error(errMessage.message); 
                }
            );
        }
    };
    
   

    const fetchSpecialStatusVehicles = () => {
        setIsFetchingTrips(true);
        let filterPayload: any = {};
        if (activeMobileFilter === 'Absent') {
            filterPayload = { absent: 1 };
        }

       

        const currentOption = vehicleOptions.find(v => String(v.id) === String(selectedVehicle));
        const vehicleNumberPlate = currentOption ? currentOption.label : '';

        getVehicle(pageSize, page,
            (response: any) => {
                setIsFetchingTrips(false);
                if (response.status === 200 && response.message?.vehicles_list) {
                    const total = response.message.total_vehicles_count || 0;
                    setTotalRecords(total);
                    setTotalCount(Math.ceil(total / pageSize));
                    setVehicleList(response.message.vehicles_list);
                    const mappedVehicles: Trip[] = response.message.vehicles_list.map((v: any) => ({
                        id: v.id,
                        vehicles_id: v.id.toString(),
                        companies_id: v.companies_id,
                        number_plate: v.number_plate,
                        status: activeMobileFilter, 
                        driver_name: v.driver_name || 'No Driver',
                        driver_phone: v.driver_phone,
                        current_location: v.current_location,
                        start_time: '',
                        end_time: '',
                        start_location: v.current_location?.address || 'Device not installed',
                        end_location: '',
                        odometer_start: 0,
                        odometer_end: 0,
                        gps_kms: 0,
                        remarks: '',
                        orders_picked: 0,
                        orders_delivered: 0,
                        initiated_by: 'system',
                        owner_name: v.owner_name,
                        make_model: v.make_model,
                        reg_date: v.reg_date,
                        fuel_type: v.fuel_type
                    }));

                    if (isMobile && page > 0) {
                        setTripsForRender(prev => [...prev, ...mappedVehicles]);
                    } else {
                        setTripsForRender(mappedVehicles);
                        if (activeMobileFilter === 'Absent') {
                            setAbsentTrips(mappedVehicles); 
                        }
                    }
                } else {
                    setTripsForRender([]);
                    setTotalRecords(0);
                }
            },
            (errMessage: any) => {
                setIsFetchingTrips(false);
                setTripsForRender([]);
                toast.error(typeof errMessage === 'string' ? errMessage : "Failed to fetch data");
            },
            filterPayload , 
            vehicleNumberPlate, 
            '',
            selectedWarehouse?.name || '',
            selectedFuelType,
        );
    };

    const fetchTripsData = () => {
        setIsFetchingTrips(true);
        getTrips(pageSize, page, selectedFromDate, selectedToDate,
            (response: any) => {
                setIsFetchingTrips(false);
                if (response.status === 400) {
                    toast.error(response.message.trips_list);
                    setTripsForRender([]);
                    setTotalRecords(0);
                } else {
                    setTotalCount(Math.ceil(response.message.total_trips_count / pageSize));
                    setTotalRecords(response.message.total_trips_count);
                    setTotalTripsOnlyCount(response.message.total_trips_count);

                    const tripsList = (response.message.trips_list || []).map((trip: any) => ({
                        ...trip,
                        start_latitude: trip.start_lat ? Number(trip.start_lat) : null,
                        start_longitude: trip.start_lng ? Number(trip.start_lng) : null,
                        end_latitude: trip.end_lat ? Number(trip.end_lat) : null,
                        end_longitude: trip.end_lng ? Number(trip.end_lng) : null,
                    }));

                    if (tripsList.length > 0) {
                        const hasIdleTrips = tripsList.some((trip: Trip) => trip.end_time);
                        const hasOnTripTrips = tripsList.some((trip: Trip) => trip.start_time && !trip.end_time);
                        
                        if (hasIdleTrips) {
                            setActiveMobileFilter('Idle');
                            sessionStorage.setItem('trips_active_tab', 'Idle');
                            setDynamicStatus('Idle');
                            setVehicleStatus('idle');
                        } else if (hasOnTripTrips) {
                            setActiveMobileFilter('On Trip');
                            sessionStorage.setItem('trips_active_tab', 'On Trip');
                            setDynamicStatus('On Trip');
                            setVehicleStatus('on_trip');
                        }
                    }

                    const initialRemarks: any = {}, initialStart: any = {}, initialEnd: any = {}, initialPicked: any = {}, initialDelivered: any = {};
                    tripsList.forEach((trip: Trip) => {
                        initialRemarks[trip.id] = trip.remarks || '';
                        initialStart[trip.id] = String(trip.odometer_start) || '';
                        initialEnd[trip.id] = String(trip.odometer_end) || '';
                        initialPicked[trip.id] = String(trip.orders_picked) || '0';
                        initialDelivered[trip.id] = String(trip.orders_delivered) || '0';
                    });

                    if (isMobile && page > 0) {
                        setTripsForRender(prev => [...prev, ...tripsList]);
                        setRemarksList(prev => ({ ...prev, ...initialRemarks }));
                        setStartReadingList(prev => ({ ...prev, ...initialStart }));
                        setEndReadingList(prev => ({ ...prev, ...initialEnd }));
                        setOrdersPickedList(prev => ({ ...prev, ...initialPicked }));
                        setOrdersDeliveredList(prev => ({ ...prev, ...initialDelivered }));
                    } else {
                        setTripsForRender(tripsList);
                        setRemarksList(initialRemarks);
                        setStartReadingList(initialStart);
                        setEndReadingList(initialEnd);
                        setOrdersPickedList(initialPicked);
                        setOrdersDeliveredList(initialDelivered);
                    }
                }
            },
            (errMessage: any) => {
                setIsFetchingTrips(false);
                if (page === 0) {
                    setTotalCount(0);
                    setTotalRecords(0);
                    setTripsForRender([]);
                }
                toast.error(errMessage);
            },
            selectedVehicle ? [selectedVehicle] : undefined, selectedWarehouse?.name || '', selectedFuelType,
            vehicleStatus
        );
    };

    const fetchAbsentDataInternal = (targetPage: number, targetPageSize: number): Promise<{ vehicles: Trip[], total: number }> => {
        return new Promise((resolve, reject) => {
            const currentOption = vehicleOptions.find(v => String(v.id) === String(selectedVehicle));
            const vehicleNumberPlate = currentOption ? currentOption.label : '';

            getAbsentVehicles(vehicleNumberPlate, targetPageSize, targetPage, selectedWarehouse?.name || '', selectedFuelType,
                (response: any) => {
                    if (response.status === 200 && response.message?.vehicles_list) {
                        const newVehiclesList = response.message.vehicles_list;
                        const total = response.message.total_vehicles_count;
                        const mappedAbsentVehicles: Trip[] = newVehiclesList.map((v: any) => ({
                            id: v.id,
                            vehicles_id: v.id.toString(),
                            companies_id: v.companies_id,
                            number_plate: v.number_plate,
                            status: 'Absent',
                            driver_name: v.driver_name || 'No Driver',
                            start_time: '',
                            end_time: '',
                            start_location: v.current_location?.address || 'Device not installed',
                            end_location: '',
                            current_location: v.current_location || null,
                            odometer_start: 0,
                            odometer_end: 0,
                            gps_kms: 0,
                            remarks: '',
                            orders_picked: 0,
                            orders_delivered: 0,
                            initiated_by: 'system',
                            driver_phone: v.driver_phone,
                            owner_name: v.owner_name,
                            make_model: v.make_model,
                            reg_date: v.reg_date,
                            fuel_type: v.fuel_type
                        }));
                        resolve({ vehicles: mappedAbsentVehicles, total });
                    } else {
                        resolve({ vehicles: [], total: 0 });
                    }
                },
                (error: any) => { resolve({ vehicles: [], total: 0 }); },
                selectedFromDate, selectedToDate
            );
        });
    };

    const fetchAbsentData = (isNextPage = false) => {
        if (isFetchingAbsent && isNextPage) return;
        if (isNextPage && !hasMoreAbsent) return;
        setIsFetchingAbsent(true);
        const targetPage = isNextPage ? absentPage + 1 : page;
        
        fetchAbsentDataInternal(targetPage, pageSize).then(data => {
            setIsFetchingAbsent(false);
            if (isNextPage) {
                setAbsentTrips(prev => [...prev, ...data.vehicles]);
                setAbsentPage(targetPage);
            } else {
                setAbsentTrips(data.vehicles);
                setAbsentPage(0);
            }
             if (data.vehicles.length < pageSize || (isNextPage ? (absentTrips.length + data.vehicles.length) : data.vehicles.length) >= data.total) {
                setHasMoreAbsent(false);
            } else {
                setHasMoreAbsent(true);
            }
        }).catch(err => {
             setIsFetchingAbsent(false);
             toast.error("Failed to load absent vehicles");
        });
    };

    const fetchData = (ignorePagination = false) => {
        if (isFetchingTrips) return;
        setIsFetchingTrips(true);
        const limitParam = ignorePagination ? '' : pageSize;
        const pageParam = ignorePagination ? '' : page;

        getTrips(limitParam, pageParam, selectedFromDate, selectedToDate,
            (response: any) => {
                setIsFetchingTrips(false);
                if (response.status === 400) {
                    toast.error(response.message.trips_list);
                    setTripsForRender([]);
                    setTotalRecords(0);
                } else {
                    setTotalCount(Math.ceil(response.message.total_trips_count / pageSize));
                    setTotalRecords(response.message.total_trips_count);

                    const tripsList = (response.message.trips_list || []).map((trip: any) => ({
                        ...trip,
                        start_latitude: trip.start_lat ? Number(trip.start_lat) : null,
                        start_longitude: trip.start_lng ? Number(trip.start_lng) : null,
                        end_latitude: trip.end_lat ? Number(trip.end_lat) : null,
                        end_longitude: trip.end_lng ? Number(trip.end_lng) : null,
                    }));

                    const initialRemarks: any = {}, initialStart: any = {}, initialEnd: any = {}, initialPicked: any = {}, initialDelivered: any = {};
                    tripsList.forEach((trip: Trip) => {
                        initialRemarks[trip.id] = trip.remarks || '';
                        initialStart[trip.id] = String(trip.odometer_start) || '';
                        initialEnd[trip.id] = String(trip.odometer_end) || '';
                        initialPicked[trip.id] = String(trip.orders_picked) || '0';
                        initialDelivered[trip.id] = String(trip.orders_delivered) || '0';
                    });

                    if (isMobile && page > 0) {
                        setTripsForRender(prev => [...prev, ...tripsList]);
                        setRemarksList(prev => ({ ...prev, ...initialRemarks }));
                        setStartReadingList(prev => ({ ...prev, ...initialStart }));
                        setEndReadingList(prev => ({ ...prev, ...initialEnd }));
                        setOrdersPickedList(prev => ({ ...prev, ...initialPicked }));
                        setOrdersDeliveredList(prev => ({ ...prev, ...initialDelivered }));
                    } else {
                        setTripsForRender(tripsList);
                        setRemarksList(initialRemarks);
                        setStartReadingList(initialStart);
                        setEndReadingList(initialEnd);
                        setOrdersPickedList(initialPicked);
                        setOrdersDeliveredList(initialDelivered);
                    }
                }
            },
            (errMessage: any) => {
                setIsFetchingTrips(false);
                if (page === 0) {
                    setTotalCount(0);
                    setTotalRecords(0);
                    setTripsForRender([]);
                }
                toast.error(errMessage);
            },
            selectedVehicle ? [selectedVehicle] : undefined, selectedWarehouse?.name || '', selectedFuelType,
            vehicleStatus
        );
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(tripsForRender.map(trip => ({
            'Sl No': (page * pageSize) + tripsForRender.indexOf(trip) + 1,
            'Vehicle Number': trip.number_plate || '',
            'Start Time': trip.start_time,
            'End Time': trip.end_time,
            'Odometer Start': trip.odometer_start,
            'Odometer End': trip.odometer_end,
            'Distance': trip.gps_kms > 0 
            ? Number(trip.gps_kms).toFixed(2) 
            : (trip.odometer_end - trip.odometer_start > 0 
                ? (trip.odometer_end - trip.odometer_start).toFixed(2) 
                : '0.00'),
            'Orders Delivered/Picked Up': `${trip.orders_delivered}/${trip.orders_picked}`,
            'Remarks': trip.remarks,
        })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Trips');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'trips_report.xlsx');
    };

    const handleCall = (phone?: string) => {
        if (!phone) { toast.error('Phone number not available'); return; }
        const sanitized = phone.replace(/\s+/g, '');
        window.location.href = `tel:${sanitized}`;
    };

    const toggleRow = (id: number) => setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    const handleEditCloseModal = () => setOpenEditModal(false);
    const handleEditClick = (id: string) => { setVehicleId(id); setOpenEditModal(true); };
    
    const handleStatusSelect = (status: string) => {
        setDynamicStatus(status);
        handleTabChange(status);
        setStatusMenuAnchor(null);
    };
    
    const handleInputChange = (event: { target: { value: React.SetStateAction<string>; }; }) => setSearchTerm(event.target.value);  
    
  const handleSearchClick = async () => {
   
    if (!searchTerm) {
        setIsSearching(false);
        fetchData(true);
        return;
    }

    setIsSearching(true);

    setIsFetchingTrips(true);
    let searchNumberPlate = '';
    let searchName = '';
    const cleanSearchTerm = searchTerm.trim();

    if (/^[a-zA-Z\s]+$/.test(cleanSearchTerm)) {
        searchName = cleanSearchTerm;
    } else {
        searchNumberPlate = cleanSearchTerm;
    }

};
    
    const handleTabChange = (newValue: string) => {
        sessionStorage.setItem('trips_active_tab', newValue);
        setActiveMobileFilter(newValue);
        if (newValue !== 'All') setDynamicStatus(newValue);
        setPage(0);
        const statusMap: Record<string, string | undefined> = { 'Idle': 'idle', 'On Trip': 'on_trip', 'Absent': '', 'All': '' };
        setVehicleStatus(statusMap[newValue] || '');
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === "fromDate") {
            setSelectedFromDate(value);
            const toDateInput = document.getElementById("toDate") as HTMLInputElement;
            if (toDateInput) toDateInput.min = value;
        } else if (name === "toDate") {
            if (new Date(value) >= new Date(selectedFromDate)) setSelectedToDate(value);
            else toast.error("To date must be greater than or equal to From date");
        }
    };

const handleVehicleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    console.log("Selected Vehicle ID:", value);
    if (!value || value === "Choose Vehicle") {
        setSelectedVehicle('');
    } else {
        setSelectedVehicle(value);
    }
    setPage(0);
};

const handleWarehouseChange = (event: SelectChangeEvent<string>) => {
    const warehouseId = event.target.value;
    console.log("Selected Warehouse ID:", warehouseId);
    if (!warehouseId || warehouseId === "Choose Warehouse" || warehouseId === "all") {
        setSelectedWarehouse(null);
    } else {
        const warehouse = warehouseOptions.find(c => c.id === warehouseId);
        setSelectedWarehouse(warehouse ? { id: warehouse.id, name: warehouse.label } : null);
    }

    setPage(0);
};

const handleFuelChange = (event: SelectChangeEvent<string>) => {
    const fuelType = event.target.value;
    if (!fuelType || fuelType === "Choose Fuel Type" || fuelType === "all") {
        setSelectedFuelType('');
    } else {
        setSelectedFuelType(fuelType);
    }
    setSelectedVehicle('');
    setPage(0);
};
    const handleCloseModal = () => { setModalOpen(false); setModalType(null); };
    const handleTripDetailsCloseModal = () => { setTripDetailsModalOpen(false); fetchData(); };

    const handleRemarksChange = (input: string | Record<string, any>, trip_id: number, type: string | null, successCallBack: any, errorCallback: any) => {
        const payload: Record<string, any> = typeof input === 'object' ? input : { [type as string]: input };
        editRemarks(trip_id, payload, successCallBack, errorCallback);
    };
    
    const handleRemarksInput = (event: React.ChangeEvent<HTMLInputElement>, trip_id: number) => {
        setRemarksList((prev) => ({ ...prev, [trip_id]: event.target.value }));
    };

    const handleCombinedOrdersChange = (e: React.ChangeEvent<HTMLInputElement>, trip_id: number) => {
        const newValue = e.target.value;
        const cursorPosition = e.target.selectionStart;
        setTempCombinedOrders(prev => ({ ...prev, [trip_id]: newValue }));
        requestAnimationFrame(() => e.target.setSelectionRange(cursorPosition, cursorPosition));
    };

    const handleCombinedOrdersBlur = (trip_id: number, currentValue: string) => {
        const [delStr, pickStr] = currentValue.split('/');
        const oldDelivered = Number(ordersDeliveredList[trip_id] || 0);
        const oldPicked = Number(ordersPickedList[trip_id] || 0);
        const newDelivered = delStr && !isNaN(Number(delStr)) ? Number(delStr) : oldDelivered;
        const newPicked = pickStr && !isNaN(Number(pickStr)) ? Number(pickStr) : oldPicked;

        if (newDelivered > newPicked) {
            toast.error("Orders delivered cannot be greater than orders picked");
            setTempCombinedOrders(prev => ({ ...prev, [trip_id]: `${oldDelivered}/${oldPicked}` }));
            return;
        }

        const payload: Record<string, string> = {};
        if (newDelivered !== oldDelivered) payload.orders_delivered = String(newDelivered);
        if (newPicked !== oldPicked) payload.orders_picked = String(newPicked);

        if (Object.keys(payload).length > 0) {
            handleOpenConfirm(() => handleRemarksChange(payload, trip_id, null, successCallBack, errorCallback), "Confirm Orders Update", "Update orders details?");
            setOrdersDeliveredList(prev => ({ ...prev, [trip_id]: String(newDelivered) }));
            setOrdersPickedList(prev => ({ ...prev, [trip_id]: String(newPicked) }));
        }
    };

    const handleCombinedOdometerChange = (e: React.ChangeEvent<HTMLInputElement>, trip_id: number) => {
        const { value, selectionStart } = e.target;
        setTempCombinedOdometer(prev => ({ ...prev, [trip_id]: value }));
        requestAnimationFrame(() => { if (e.target && selectionStart !== null) e.target.setSelectionRange(selectionStart, selectionStart); });
    };

    const handleCombinedOdometerBlur = (trip_id: number, currentValue: string) => {
        const [startStr, endStr] = currentValue.split('/');
        const oldStart = Number(startReadingList[trip_id] || 0);
        const oldEnd = Number(endReadingList[trip_id] || 0);
        const newStart = startStr && !isNaN(Number(startStr)) ? Number(startStr) : oldStart;
        const newEnd = endStr && !isNaN(Number(endStr)) ? Number(endStr) : oldEnd;
        if (newEnd < newStart && newEnd !== 0) {
             toast.error("Odometer end cannot be less than start");
             setTempCombinedOdometer(prev => ({ ...prev, [trip_id]: `${oldStart}/${oldEnd}` }));
             return;
        }
        const payload: Record<string, string> = {};
        if (newStart !== oldStart) payload.odometer_start = String(newStart);
        if (newEnd !== oldEnd) payload.odometer_end = String(newEnd);

        if (Object.keys(payload).length > 0) {
            handleOpenConfirm(() => handleRemarksChange(payload, trip_id, null, successCallBack, errorCallback), "Confirm Odometer Update", "Update odometer details?");
             setStartReadingList(prev => ({ ...prev, [trip_id]: String(newStart) }));
             setEndReadingList(prev => ({ ...prev, [trip_id]: String(newEnd) }));
        }
    };

    const handleEditSave = (payload: { odometer_start: number; odometer_end: number; orders_picked: number; orders_delivered: number; }) => {
        if (!selectedEditTrip) return;
        const tripId = selectedEditTrip.id;
        const changedParams: Record<string, string> = {};

        if (payload.odometer_start !== selectedEditTrip.odometer_start) changedParams.odometer_start = payload.odometer_start.toString();
        if (payload.odometer_end !== selectedEditTrip.odometer_end) changedParams.odometer_end = payload.odometer_end.toString();
        if (payload.orders_picked !== selectedEditTrip.orders_picked) changedParams.orders_picked = payload.orders_picked.toString();
        if (payload.orders_delivered !== selectedEditTrip.orders_delivered) changedParams.orders_delivered = payload.orders_delivered.toString();

        if (Object.keys(changedParams).length === 0) {
            toast.info('No changes to save');
            return;
        }
        editRemarks(tripId, changedParams, successCallBack, errorCallback);
        setEditModalOpen(false);
        setSelectedEditTrip(null);
    };
    
    const handleCloseAddVehicle = () => setIsAddVehicleOpen(false);
    
    const handleOpenConfirm = (action: () => void, title: string, message: string) => { setPendingAction(() => action); setConfirmTitle(title); setConfirmMessage(message); setConfirmOpen(true); };
    const handleCloseConfirm = () => { setConfirmOpen(false); setPendingAction(null); fetchData(); };
    const handleConfirm = () => { if (pendingAction) pendingAction(); handleCloseConfirm(); };

    const handleDeleteTrip = (tripId: string | number) => {
        const deleteAction = () => {
            deleteTrip(tripId,
                (response: any) => {
                    if (response.status === 200) {
                        toast.success('Trip deleted successfully');
                        if (activeMobileFilter === 'All') fetchData();
                        else if (activeMobileFilter === 'On Trip' || activeMobileFilter === 'Idle') fetchTripsData();
                        else if (activeMobileFilter === 'Absent') fetchSpecialStatusVehicles();
                        else fetchData();
                    }
                },
                (errMessage: any) => {
                    toast.error(errMessage?.message || 'Failed to delete trip');
                }
            );
        };
        handleOpenConfirm(deleteAction, 'Delete Trip', 'Are you sure you want to delete this trip?');
    };

    const successCallBack = (response: any) => {
        if (response.status === 200) { 
            toast.success(response.message); 
            if (activeMobileFilter === 'All') fetchData();
            else if (activeMobileFilter === 'On Trip' || activeMobileFilter === 'Idle') fetchTripsData(); 
            else if (activeMobileFilter === 'Absent') fetchSpecialStatusVehicles();
            else fetchData(); 
        }
        else if (response.status === 400) { toast.error(response.message); }
    };
    const errorCallback = (errorMsg: string) => { toast.error(errorMsg); };
    
    const updateField = (event: SelectChangeEvent<string>) => { const value = event.target.value; if (!isNaN(Number(value))) { setPageSize(Number(value)); setPage(0); } };
    const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => { setPage(newPage - 1); };

const formatAddress = (location: string | null) => {
    if (!location) return "Location not captured";
    const parts = location.split(',').map(p => p.trim()).filter(p => p.length > 0);
    let targetSegment = parts.length >= 4 ? parts[parts.length - 4] : parts[0];
    if (!targetSegment) return "Location not captured";

    const words = targetSegment.split(/\s+/);
    const lastTwo = words.length >= 2 ? words.slice(-2) : words;
    
    if (lastTwo.length === 2 && (lastTwo[0].toLowerCase() === 'in' || lastTwo[0].toLowerCase() === 'near')) {
        return lastTwo[1];
    }
    return lastTwo.join(' ');
};

    const handleRefreshLocation = (e: React.MouseEvent, idToRefresh: string) => {
        e.stopPropagation();
        getCurrentLocation(
            (response: any) => {
                if (response.status === 200 && response.data && response.data.length > 0) {
                    const updatedInfo = response.data[0];
                    setTripsForRender((prevTrips) =>
                        prevTrips.map((trip) => {
                            if (String(trip.vehicles_id) === String(updatedInfo.vehicle_id)) {
                                return {
                                    ...trip,
                                    start_location: updatedInfo.address,
                                    current_location: { ...trip.current_location, lat: updatedInfo.lat, lng: updatedInfo.lng, address: updatedInfo.address }
                                };
                            }
                            return trip;
                        })
                    );
                }
            },
            (errMessage: any) => { toast.error(typeof errMessage === 'string' ? errMessage : "Failed to update location"); },
            [idToRefresh]
        );
    };

    const handleLocationClick = (startLocation: string, endLocation: string) => { setModalStartLocation(startLocation); setModalEndLocation(endLocation); setModalOpen(true); };
    const handleStartTrip = () => { setModalType('start'); setTripDetailsModalOpen(true); };
    const handleEndTrip = (tripId: any, vehicleId: any) => { setVehicleId(vehicleId); setTripId(tripId); setModalType('end'); setTripDetailsModalOpen(true); };
    const getLocationIconColor = (location: string): string => {
        if (!location || typeof location !== 'string') return 'inherit';
        const lower = location.toLowerCase();
        if (lower.startsWith('in ')) return 'green';
        if (lower.startsWith('near ')) return 'orange';
        return 'blue';
    };

    const fitMapToAllTrips = () => {
        const map = mapRef.current;
        if (!map || filteredTrips.length === 0) return;
        const bounds = new google.maps.LatLngBounds();
        let hasValidPoints = false;
        filteredTrips.forEach((t) => {
            const lat = Number(t?.current_location?.lat);
            const lng = Number(t?.current_location?.lng);
            if (lat && lng) { bounds.extend({ lat, lng }); hasValidPoints = true; }
        });
        if (hasValidPoints) {
            map.fitBounds(bounds);
            if (filteredTrips.length === 1) map.setZoom(16);
        } else {
            map.setCenter({ lat: 12.9716, lng: 77.5946 });
            map.setZoom(10);
        }
    };

    const handleMobileScroll = (e: React.UIEvent<HTMLDivElement>) => {
        if (isFetchingTrips || isFetchingAbsent) return;
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        const isAtBottom = scrollHeight - scrollTop <= clientHeight + 50;

        if (isAtBottom) {
            if (activeMobileFilter === 'Absent') {
                if (hasMoreAbsent) fetchAbsentData(true);
            } else {
                const maxPage = Math.ceil(totalRecords / pageSize);
                const nextPage = page + 1;
                if (nextPage < maxPage) setPage(nextPage);
                else console.log("Reached last page. No more fetching.");
            }
        }
    };
    const columns: GridColDef[] = [
        { field: 'sl_no', headerName: 'Sl No', width: 40, headerAlign: 'center', align: 'center', renderCell: (params) => params.value },
        {
            field: 'Vehicle_no',
            headerName: 'Vehicle Number',
            width: 150, 
            headerAlign: 'center',
            align: 'center',            
            renderCell: (params) => {
                const parts = params.value.split('/');
                const isParent = params.row.isParent;
                const isChild = params.row.isChild;
                const isExpanded = expandedRows[params.row.id];

                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%', width: '100%', paddingLeft: isChild ? '30px' : '0px' }}>
                        {isParent ? (
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleRow(params.row.id); }} sx={{ marginRight: '8px' }}>
                                {isExpanded ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                            </IconButton>
                        ) : (
                            <Box sx={{ width: '28px', display: isChild ? 'none' : 'block' }} />
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                            <div style={{ color: isChild ? '#555' : 'inherit' }}>{parts[0]}</div>
                            <div style={{ color: '#666' }}>{parts[1]}</div>
                        </div>
                    </div>
                );
            }
        },
        { field: 'start_time', headerName: 'Start Time', width: 100, headerAlign: 'center', align: 'center', renderCell: (params) => params.value },
        {
            field: 'end_time', headerName: 'End Time', width: 120, headerAlign: 'center', align: 'center', renderCell: (params) => {
                if (params.row.start_time && !params.value) {
                    const isHandover = params.row.status === 'handover';
                    const isDriver = params.row.initiated_by === 'driver' || !params.row.initiated_by;
                    const isVendor = params.row.initiated_by === 'vendor_supervisor' || params.row.initiated_by === 'vendor_company_admin';

                    if (isClientCompanyAdmin && isHandover) {
                        return (<Button variant="contained" style={{ backgroundColor: 'orange', color: 'white' }} size="small" onClick={() => { setVehicleId(params.row.vehicles_id); setTripId(params.row.id); setModalType('handover'); setTripDetailsModalOpen(true); }}>Handover Accept</Button>);
                    }
                    if (!isClientCompanyAdmin) {
                        if (isHandover) return <Button variant="contained" style={{ backgroundColor: 'orange', color: 'white', borderRadius: '20px' }} size="small" onClick={() => { setVehicleId(params.row.vehicles_id); setTripId(params.row.id); setModalType('handover'); setTripDetailsModalOpen(true); }}>Handover Accept</Button>;
                        if (isDriver) return <Button variant="contained" style={{ backgroundColor: 'red', color: 'white', borderRadius: '20px' }} size="small" onClick={() => handleEndTrip(params.row.id, params.row.vehicles_id)}>End Trip</Button>;
                        if (isVendor) return <Button variant="contained" style={{ backgroundColor: '#ef6363', color: 'white', borderRadius: '20px' }} size="small" onClick={() => handleEndTrip(params.row.id, params.row.vehicles_id)}>End Trip</Button>;
                        return <Button variant="contained" style={{ backgroundColor: 'purple', color: 'white', borderRadius: '20px' }} size="small" onClick={() => { setVehicleId(params.row.vehicles_id); setTripId(params.row.id); setModalType('end'); setTripDetailsModalOpen(true); }}>Forced Handover</Button>;
                    }
                }
                return params.value;
            }
        },
         {
            field: 'odometer_reading_combined',
            headerName: 'Odometer (Start/End)',
            width: 200,
            align: 'center',
            editable: true,
            headerAlign: 'center',
            renderCell: (params) => {
               const start = startReadingList[params.row.id] ?? params.row.odometer_reading_start ?? '';
                const end = endReadingList[params.row.id] ?? params.row.odometer_reading_end ?? '';
                const urlStart = params.row.odometer_start;
                const urlEnd = params.row.odometer_end;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid grey', borderRadius: '5px', outline: 'none', boxShadow: 'none', width: '100%', height: '100%', boxSizing: 'border-box', gap: '5px' }}>
                        <div>{start} / {end}</div>
                        {urlStart && ( <a href={`${global.odometer_image_url}${urlStart}`} target="_blank" rel="noopener noreferrer" download><i className="fas fa-download" style={{ fontSize: '10px' }}></i></a> )}
                        {urlEnd && ( <a href={`${global.odometer_image_url}${urlEnd}`} target="_blank" rel="noopener noreferrer" download><i className="fas fa-download" style={{ fontSize: '10px', color: 'red' }}></i></a> )}
                    </div>
                );
            },
            renderEditCell: (params: GridRenderCellParams) => {
                const initialVal = `${startReadingList[params.row.id] ?? '0'}/${endReadingList[params.row.id] ?? '0'}`;
                return (
                    <input type="text" value={tempCombinedOdometer[params.row.id] ?? initialVal} onChange={(e) => handleCombinedOdometerChange(e, params.row.id)} onBlur={(e) => handleCombinedOdometerBlur(params.row.id, e.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') handleCombinedOdometerBlur(params.row.id, (event.target as HTMLInputElement).value); }} style={{ border: '1px solid black', outline: 'none', boxShadow: 'none', width: '100%', textAlign: 'center' }} />
                );
            },
        },
        {
    field: 'gps_km',
    headerName: 'GPS KM',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
        const gpsKms = Number(params.row.gps_kms);
        if (gpsKms > 0) {
            return gpsKms.toFixed(2);
        }
        const start = Number(params.row.odometer_reading_start);
        const end = Number(params.row.odometer_reading_end);

        if (start > 0 && end > 0) {
            const diff = end - start;
            return diff >= 0 ? diff.toFixed(2) : "0.00";
        }

        return "0.00";
    }
},
        {
            field: 'orders_combined',
            headerName: 'Orders (Del/Pick)',
            width: 140,
            editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const del = ordersDeliveredList[params.row.id] ?? params.row.orders_delivered ?? '0';
                const pick = ordersPickedList[params.row.id] ?? params.row.orders_picked ?? '0';
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid grey', borderRadius: '5px', outline: 'none', boxShadow: 'none', width: '100%', height: '100%', boxSizing: 'border-box', }}>
                        {del} / {pick}
                    </div>
                );
            },
            renderEditCell: (params: GridRenderCellParams) => {
                const initialVal = `${ordersDeliveredList[params.row.id] ?? '0'}/${ordersPickedList[params.row.id] ?? '0'}`;
                return (
                    <input type="text" value={tempCombinedOrders[params.row.id] ?? initialVal} onChange={(e) => handleCombinedOrdersChange(e, params.row.id)} onBlur={(e) => handleCombinedOrdersBlur(params.row.id, e.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') handleCombinedOrdersBlur(params.row.id, (event.target as HTMLInputElement).value); }} style={{ border: '1px solid black', outline: 'none', boxShadow: 'none', width: '100%', textAlign: 'center', }} />
                );
            },
        },
   {
    field: 'actions',
    headerName: 'Location',
    width: 180,
    align: 'left',
    headerAlign: 'center',
    renderCell: (params) => {
        const hasTripData = !!params.row.start_time;
        const sLoc = String(params.row.start_location || '');
        const eLoc = String(params.row.end_location || '');
        
        if (!sLoc || sLoc.trim() === '' || sLoc === 'Device not installed') return null; 

      const handleLocationClickNewTab = (e: React.MouseEvent) => {
    e.stopPropagation();

    const stateData = { 
        tripId: params.row.id, 
        vehicleNo: params.row.number_plate, 
        vehiclesId: params.row.vehicles_id, 
        driverName: params.row.driver_name, 
        startLat: params.row.start_latitude, 
        startLng: params.row.start_longitude, 
        endLat: params.row.end_latitude, 
        endLng: params.row.end_longitude, 
        startLocation: params.row.start_location, 
        endLocation: params.row.end_location, 
        deviceId: params.row?.current_location?.device_id, 
        orders: params.row.orders_picked, 
        distance: params.row.gps_kms, 
        status: params.row.status, 
        driverPhone: params.row.driver_phone,
        rawStartTime: params.row.raw_start_time,
        vehicleList: vehicleList, 
        fromHistory: true, 
        activeMobileFilter: activeMobileFilter,
        referrer: '/trips'
    };

    const stateKey = `trip_state_${Date.now()}`;
    localStorage.setItem(stateKey, JSON.stringify(stateData));
    
    navigate(`/trips/directions?stateKey=${stateKey}`, { state: stateData });
};

        if (!hasTripData) {
            return (
                <div 
                    onClick={handleLocationClickNewTab}
                    style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '0.75rem', lineHeight: '1.4', padding: '4px 0', width: '100%' }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px', gap: '6px' }}>
                        <Tooltip title={sLoc}>
                            <LocationOnIcon fontSize="small" style={{ color: 'blue', marginTop: '2px', flexShrink: 0 }} />
                        </Tooltip>
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, wordBreak: 'break-word' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '4px', fontSize: '0.7rem' }}>Current:</span>
                            <span style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}>{sLoc}</span>
                        </div>
                    </div>
                </div>
            );
        }
        
        return (
            <div 
                onClick={handleLocationClickNewTab}
                style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '0.75rem', lineHeight: '1.4', padding: '4px 0', width: '100%' }}
            >
                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px', gap: '6px' }}>
                    <Tooltip title={sLoc}>
                        <LocationOnIcon fontSize="small" style={{ color: 'green', marginTop: '2px', flexShrink: 0 }} />
                    </Tooltip>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, wordBreak: 'break-word' }}>
                        <span style={{ fontWeight: 'bold', marginRight: '4px', fontSize: '0.7rem' }}>Start:</span>
                        <span style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}>{sLoc}</span>
                    </div>
                </div>
                {eLoc && (
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                        <Tooltip title={eLoc}>
                            <LocationOnIcon fontSize="small" style={{ color: 'red', marginTop: '2px', flexShrink: 0 }} />
                        </Tooltip>
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, wordBreak: 'break-word' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '4px', fontSize: '0.7rem' }}>End:</span>
                            <span style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}>{eLoc}</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
},
        {
            field: 'row_actions',
            headerName: 'Actions',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => {
                const canEdit = String(companiesId) === String(params.row.companies_id);
                return (
                    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                      
                            <>
                               {activeMobileFilter !== 'Absent' && (
                            <Tooltip title="Delete Trip">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDeleteTrip(params.row.id); }} >
                                    <DeleteOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                            </>
                      
                    </Box>
                );
            }
        },
   {
  field: 'remarks',
  headerName: 'Remarks',
  flex:1,
  minWidth: 140,
  editable: (params: { row: { start_time: any; }; }) => !!params.row.start_time, 
  renderCell: (params) => {
    const value = remarksList[params.row.id] ?? '';
    const hasTrip = !!params.row.start_time;

    return (
      <Box
        sx={{
          width: '100%',
          height: '80%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 8px',
          borderRadius: '4px',
          border: hasTrip ? '1px solid grey' : 'none',
          backgroundColor: 'transparent',
          cursor: hasTrip ? 'pointer' : 'default',
          '&:hover': {
            backgroundColor: hasTrip ? '#f0f0f0' : 'transparent',
          },
        }}
      >
        {value}
      </Box>
    );
  },
  renderEditCell: (params) => {
    return (
      <input
        type="text"
        autoFocus
        value={remarksList[params.row.id] ?? ''}
        onChange={(e) => handleRemarksInput(e, params.row.id)}
        onBlur={() => {
          const newValue = remarksList[params.row.id];
          const oldValue = params.row.remarks;
          if (newValue !== oldValue) {
            handleRemarksChange(newValue, params.row.id, 'remarks', successCallBack, errorCallback);
          }
        }}
        style={{
          width: '100%',
          border: '2px solid #1976d2', 
          padding: '4px',
          outline: 'none'
        }}
      />
    );
  }
}
    ];

   const platformColumns: GridColDef[] = [
    { field: 'sl_no', headerName: 'Sl.No', width: 70 },
    { field: 'number_plate', headerName: 'Vehicle Number', flex: 1 },
    { field: 'driver_name', headerName: 'Driver name', flex: 1 },
    { 
        field: 'owner', 
        headerName: 'Owner', 
        flex: 1, 
        valueGetter: (value, row) => row?.owner_name || '-' 
    }, 
    { 
        field: 'make_model', 
        headerName: 'Model', 
        flex: 1, 
        valueGetter: (value, row) => row?.make_model || '-' 
    },
    { 
        field: 'make_year', 
        headerName: 'Make Year', 
        flex: 1, 
        valueGetter: (value, row) => {
            const dateStr = row?.make_year;
            if (!dateStr || dateStr === '-') return '-';
            if (/^\d{4}$/.test(dateStr)) {
                return `01/01/${dateStr}`;
            }
            const dateObj = new Date(dateStr);
            if (!isNaN(dateObj.getTime())) {
                const day = String(dateObj.getDate()).padStart(2, '0');
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const year = dateObj.getFullYear();
                return `${day}/${month}/${year}`;
            }
            
            return dateStr;
        } 
    },
    { 
        field: 'fuel_type', 
        headerName: 'Fuel Type', 
        flex: 1, 
        valueGetter: (value, row) => row?.fuel_type || '-' 
    },
    { 
        field: 'actions', 
        headerName: 'Actions', 
        width: 140, 
        sortable: false,
        renderCell: (params) => (
            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              {activeMobileFilter !== 'Absent' && (
                            <Tooltip title="Delete Trip">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDeleteTrip(params.row.id); }} >
                                    <DeleteOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        )}
            </Box>
        )
    }
];

    const filteredTrips = useMemo(() => {
        if (selectedVehicle) {
            return tripsForRender.filter(trip => !trip.vehicles_id || String(trip.vehicles_id) === String(selectedVehicle));
        }
        if (activeMobileFilter === 'On Trip') return tripsForRender.filter(trip => trip.status?.toLowerCase().includes('started') || trip.status?.toLowerCase().includes('on_trip'));
        if (activeMobileFilter === 'Idle') return tripsForRender.filter(trip => trip.status?.toLowerCase().includes('ended') || trip.status?.toLowerCase().includes('idle'));
        if (activeMobileFilter === 'Absent') return absentTrips;
        return tripsForRender;
    }, [activeMobileFilter, tripsForRender, absentTrips, selectedVehicle, pageSize, isSearching]);

    const createRowFromTrip = (trip: any, index: number, isChild: boolean = false) => ({
        id: trip.id,
        vehicles_id: trip.vehicles_id,
        companies_id: trip.companies_id, 
        sl_no: isChild ? '' : (page * pageSize) + index + 1, 
        Vehicle_no: `${trip.number_plate || 'Unknown'}/${trip.driver_name || 'Unknown'}`,
        number_plate: trip.number_plate,
        start_time: formatDate(trip.start_time),
        raw_start_time: trip.start_time,
        end_time: trip.end_time ? formatDate(trip.end_time) : null,
        odometer_reading_start: trip.odometer_start,
        odometer_reading_end: trip.odometer_end,
        odometer_start: trip.odometer_start_upload_url,
        odometer_end: trip.odometer_end_upload_url,
        distance_travelled: trip.odometer_end - trip.odometer_start < 0 ? '' : trip.odometer_end - trip.odometer_start,
        gps_km: trip.gps_kms ? Number(trip.gps_kms).toFixed(2) : '',
        remarks: trip.remarks,
        initiated_by: trip.initiated_by,
        start_location: trip.start_location,
        end_location: trip.end_location,
        status: trip.status,
        orders_picked: trip.orders_picked,
        orders_delivered: trip.orders_delivered,
        driver_name: trip.driver_name,
        start_latitude: trip.start_latitude,
        start_longitude: trip.start_longitude,
        end_latitude: trip.end_latitude,
        end_longitude: trip.end_longitude,
        related_trips: trip.related_trips, 
        isChild: isChild,
        owner_name: trip.owner_name,
    make_model: trip.make_model,
    make_year: trip.reg_date,
    fuel_type: trip.fuel_type,
        isParent: !isChild && (trip.related_trips && trip.related_trips.length > 0)
    });

    const rows = useMemo(() => {
        const flattenedRows: any[] = [];
        filteredTrips.forEach((trip, index) => {
            flattenedRows.push(createRowFromTrip(trip, index, false));
            if (expandedRows[trip.id] && trip.related_trips && trip.related_trips.length > 0) {
                trip.related_trips.forEach((childTrip: any) => {
                    flattenedRows.push(createRowFromTrip(childTrip, index, true));
                });
            }
        });
        return flattenedRows;
    }, [filteredTrips, expandedRows, page, pageSize]);

    const activeTotalRecords = totalRecords;

    return (
        <>
            <Header />
            <div style={{ marginTop: "70px",  marginLeft:  "0px" }}>
                {!isMobile && (
                    <Heading 
                        title="Trips" 
                        closeIcon="false" 
                        page='trips'
                    leftContent={
                     
            <>
                <Box sx={{ marginRight: '10px', marginBottom: { xs: '10px', lg: '0px' } }}>
                    <Dropdown 
                        options={fuelTypeOptions} 
                        selectedValue={selectedFuelType} 
                        handleChange={handleFuelChange} 
                        placeholder="Choose Fuel Type" 
                        label="Choose Fuel Type" 
                        width='190px' 
                        height='50px' 
                    />
                </Box>
                 <Box sx={{ marginRight: '10px', marginBottom: { xs: '10px', lg: '0px' } }}>
                <Dropdown 
                    options={warehouseOptions} 
                    searchable={true} 
                    selectedValue={selectedWarehouse?.id || ''} 
                    handleChange={handleWarehouseChange} 
                    placeholder="Choose Warehouse" 
                    label="Choose Warehouse" 
                    width='190px' 
                    height='50px' 
                />
                </Box>
        <Box sx={{ marginRight: '10px', marginBottom: { xs: '10px', lg: '0px' } }}>

                <Dropdown
                            options={vehicleOptions}
                            selectedValue={selectedVehicle}
                            handleChange={handleVehicleChange}
                            searchable={true}
                            placeholder="Choose Vehicle"
                            label="Choose Vehicle"
                            width="190px"
                            height="50px"
                        />
</Box>
            </>
        
    }
        
        rightContent={<>
                <>
                    <DatePicker id="fromDate" name="fromDate" value={selectedFromDate} label="From" onChange={handleDateChange} />
                    <Box sx={{ marginLeft: { xs: '20px', md: '0px' } }}>
                        <DatePicker id="toDate" name="toDate" value={selectedToDate} label="To" onChange={handleDateChange} />
                    </Box>
                </>
   
        </>}
    />
)}

                { isMobile ? (
                    <TripsMobileView
                        filteredTrips={filteredTrips}
                        currentTabs={currentTabs}
                        activeMobileFilter={activeMobileFilter}
                        handleTabChange={handleTabChange}
                        dynamicStatus={dynamicStatus}
                        statusMenuAnchor={statusMenuAnchor}
                        setStatusMenuAnchor={setStatusMenuAnchor}
                        tripOptions={tripOptions}
                        handleStatusSelect={handleStatusSelect}
                        searchTerm={searchTerm}
                        handleInputChange={handleInputChange}
                        handleSearchClick={handleSearchClick}
                        showMobileFilters={showMobileFilters}
                        setShowMobileFilters={setShowMobileFilters}
                        fuelTypeOptions={fuelTypeOptions}
                        selectedFuelType={selectedFuelType}
                        handleFuelChange={handleFuelChange}
                        warehouseOptions={warehouseOptions}
                        selectedWarehouse={selectedWarehouse}
                        handleWarehouseChange={handleWarehouseChange}
                        selectedFromDate={selectedFromDate}
                        selectedToDate={selectedToDate}
                        handleDateChange={handleDateChange}
                        handleMobileScroll={handleMobileScroll}
                        activeTripId={activeTripId}
                        handleRefreshLocation={handleRefreshLocation}
                        handleCall={handleCall}
                        setSelectedEditTrip={setSelectedEditTrip}
                        setEditModalOpen={setEditModalOpen}
                        formatAddress={formatAddress}
                        vehicleOptions={vehicleOptions}
                        selectedVehicle={selectedVehicle}
                        handleVehicleChange={handleVehicleChange}
                        vehicleList={vehicleList}
                        handleDeleteTrip={handleDeleteTrip}
                        companiesId={companiesId}
                    />
                ) : (
                    <TripsDesktopView
                        orderRef={orderRef}
                        currentTabs={currentTabs}
                        activeMobileFilter={activeMobileFilter}
                        handleTabChange={handleTabChange}
                        statusMenuAnchor={statusMenuAnchor}
                        setStatusMenuAnchor={setStatusMenuAnchor}
                        pageSize={pageSize}
                        updateField={updateField}
                        showEntries={showEntries}
                        searchTerm={searchTerm}
                        handleInputChange={handleInputChange}
                        handleSearchClick={handleSearchClick}
                        isClientCompanyAdmin={isClientCompanyAdmin}
                        handleStartTrip={handleStartTrip}
                        showMap={showMap}
                        setShowMap={setShowMap}
                        exportToExcel={exportToExcel}
                        rows={rows}
                        columns={columns}
                        totalRecords={totalRecords}
                        filteredTrips={filteredTrips}
                        activeTotalRecords={activeTotalRecords}
                        page={page}
                        handlePageClick={handlePageClick}
                        tripOptions={tripOptions}
                        dynamicStatus={dynamicStatus}
                        handleStatusSelect={handleStatusSelect}
                        mapRef={mapRef}
                        fitMapToAllTrips={fitMapToAllTrips} 
                    />
                )}

                <ConfirmationPopup open={confirmOpen} onClose={handleCloseConfirm} onConfirm={handleConfirm} title={confirmTitle} message={confirmMessage} />
                <LocationModal open={modalOpen} onClose={handleCloseModal} startLocation={modalStartLocation} endLocation={modalEndLocation} />
                <TripDetailsModal isOpen={tripDetailsModalOpen} onClose={handleTripDetailsCloseModal} type={modalType || 'start'} tripId={tripId} vehicleId={vehicleId} vehicleList={vehicleList} orderPicked={selectedTripOrdersPicked} orderDelivered={selectedTripOrdersDelivered} />
                <EditTripModal open={editModalOpen} trip={selectedEditTrip} onClose={() => { setEditModalOpen(false); setSelectedEditTrip(null); }} onSave={handleEditSave} />
                <EditVehicleModal open={openEditModal} onClose={handleEditCloseModal} vehicle={vehicleList?.find((v: any) => String(v.id) === String(vehicleId)) || null} tab='active' />
            </div>
            <QueryWidget />
            
            <NavBar selected='Trips' />
        </>
    );
};

export default Trips;